import { getApiClient } from "@src/api";
import { graduatedBetaResultSchema } from "@src/components/plan/plan-schemas";
import { graphql } from "@src/gql/gql";
import { handleError } from "@src/utils/error-handling";
import { useMutation } from "@tanstack/react-query";

const graduateFromBetaMutation = graphql(/* GraphQL */ `
	mutation GraduateFromBeta {
		user {
			graduateFromBeta {
				wasMigrated
				plan {
					position
					state {
						internalUserId
						provider
						renewsAt
						status
						trialEndsAt
					}
				}
			}
		}
	}
`);

export const graduateFromBetaMutationFn = async () => {
	const client = getApiClient();
	const result = await client.mutate({
		mutation: graduateFromBetaMutation,
	});

	const payload = result.data?.user?.graduateFromBeta;

	if (!payload) {
		return null;
	}

	return graduatedBetaResultSchema.parse(payload);
};

export const graduateFromBetaMutationOptions = {
	mutationFn: graduateFromBetaMutationFn,
	onError: (error: Error) => {
		handleError(error, "Failed to graduate beta user");
	},
};

export const useGraduateFromBeta = () =>
	useMutation(graduateFromBetaMutationOptions);
